export const Gaps = {
    defaultGap: '1.2rem' //Default padding or margin in all directions
}